import React from 'react';
import axios from 'axios'
import { Table,Tabs, Input, Button,DatePicker,Collapse,Form,Popover,Popconfirm,message,Spin } from 'antd';

import Highlighter from 'react-highlight-words';
import Icon from '@ant-design/icons';
import { SearchOutlined,DownloadOutlined,DeleteOutlined,UndoOutlined,FundViewOutlined,LoadingOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import * as serverconfig from '../serverconn'
import ReactExport from "@ibrahimrahmani/react-export-excel";
import moment from 'moment';

var CryptoJS = require("crypto-js");

const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const { TabPane } = Tabs;
const dateFormat = 'DD/MM/YYYY';
const FormItem=Form.Item;

const { RangePicker } = DatePicker;

function callback(key) {
  console.log(key);
}

var sacco= ''
var token= ''

class SystemLogList extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    systemactivitylogs: [],
    datarequested:true,
    dateone:moment().format(dateFormat).toString(),
    datetwo:moment().format(dateFormat).toString(),


  };

  componentDidMount(){

    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
    }else{
       sacco= ''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }


    //search items
    this.searchItems()


}


getColumnSearchProps = dataIndex => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Input
        ref={node => {
          this.searchInput = node;
        }}
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
      />
      <Button
        type="primary"
        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        icon={<SearchOutlined />}
        size="small"
        style={{ width: 90, marginRight: 8 }}
      >
        Search
      </Button>
      <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
        Reset
      </Button>
    </div>
  ),
  filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
  onFilter: (value, record) =>
    record[dataIndex]
      .toString()
      .toLowerCase()
      .includes(value.toLowerCase()),
  onFilterDropdownVisibleChange: visible => {
    if (visible) {
      setTimeout(() => this.searchInput.select());
    }
  },
  render: text =>
    this.state.searchedColumn === dataIndex ? (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ) : (
      text
    ),
});

handleSearch = (selectedKeys, confirm, dataIndex) => {
  confirm();
  this.setState({
    searchText: selectedKeys[0],
    searchedColumn: dataIndex,
  });
};

handleReset = clearFilters => {
  clearFilters();
  this.setState({ searchText: '' });
};


//search items
searchItems=()=>{
  this.setState({systemactivitylogs:[]})


  let form_data = new FormData();
  form_data.append('sacco', sacco);
  form_data.append('dateone', this.state.dateone);
  form_data.append('datetwo', this.state.datetwo);
  if(this.state.dateone===''||this.state.datetwo===''){
    message.error("Please dates are missing")
  }else{
      this.setState({datarequested:true})

      //Now submit sale data to database
      axios.post(serverconfig.backendserverurl+'/customqueries/get_systemlogs', form_data,{
      headers: {
        'content-type': 'multipart/form-data'
      }
      })
      .then(res =>{
        this.setState({datarequested:false})
        this.setState({systemactivitylogs:JSON.parse(res.data.report)})
      } 
      )
      .catch(error => console.log(error))   
  }



}

handledatechange= (date, dateString) =>{
  this.setState({ dateone: dateString[0]});
  this.setState({ datetwo: dateString[1]});
} 



  render() {
    const columns = [
      {
        title: 'Date',
        dataIndex: 'date',
        key: 'id',
        ...this.getColumnSearchProps('date'),
      },
      {
        title: 'Activity',
        dataIndex: 'activity_name',
        key: 'id',
        ...this.getColumnSearchProps('activity_name'),
      },
     
    ];


    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      return(
       <div>

      
    <Collapse defaultActiveKey={['1']} onChange={this.callback}>
          <Panel header="SYSTEM ACTIVITY LOGS" key="1">
          <Form  layout="inline" >

          <FormItem label="Date Range">
               <RangePicker onChange={this.handledatechange} format={dateFormat} />
          </FormItem>

          <FormItem>
          <Button onClick={()=>{ this.searchItems()}} type="primary" htmlType="button">Search</Button>
          </FormItem>

          <FormItem>
          <ExcelFile filename={"Pisacco - Systemlogs report from "+this.state.dateone+" to "+this.state.datetwo}  element={<Button type='primary' icon={<DownloadOutlined/>}>Download Excel</Button>} >
                <ExcelSheet data={this.state.systemactivitylogs} name="System logs">
                    <ExcelColumn label="Date" value="date"/>
                    <ExcelColumn label="Activity" value="activity_name"/>
                </ExcelSheet>
          </ExcelFile>

          </FormItem>
          
          </Form> 
    

          <br></br>
          <br></br>

          <Table 
          columns={columns} 
          scroll={{ x: 1000 }}
          pagination={{showQuickJumper:true,showSizeChanger:true }}
          dataSource={this.state.systemactivitylogs} 
          bordered/>
          </Panel>
          </Collapse>

 

</div>)

}
    
  }
}

export default SystemLogList; 
